const MATERIAL_MAX_BYTES = 100 * 1024 * 1024;
const ALLOWED_EXTENSIONS = new Set([
  'jpg', 'jpeg', 'png', 'gif', 'webp', 'heic',
  'pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv', 'txt', 'md', 'ppt', 'pptx',
]);

export const MAX_UPLOAD_FILES = 100;

export const getExt = (name = '') => String(name || '').split('.').pop()?.toLowerCase() || '';

export const getFileIcon = (name = '') => {
  const ext = getExt(name);
  if (ext === 'pdf') return 'fa-file-pdf';
  if (ext === 'csv') return 'fa-file-csv';
  if (['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg', 'heic'].includes(ext)) return 'fa-file-image';
  if (['txt', 'md', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(ext)) return 'fa-file-lines';
  return 'fa-file';
};

export const formatBytes = (value) => {
  const bytes = Number(value);
  if (!Number.isFinite(bytes) || bytes < 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(kb >= 10 ? 0 : 1)} KB`;
  const mb = kb / 1024;
  if (mb < 1024) return `${mb.toFixed(mb >= 10 ? 0 : 1)} MB`;
  return `${(mb / 1024).toFixed(1)} GB`;
};

const nonBlank = (value) => {
  const text = value === undefined || value === null ? '' : String(value).trim();
  return text || '';
};

export const materialDownloadActorRoleLabel = (row = {}) => {
  const label = nonBlank(row.actor_role_label);
  if (label) return label;
  if (row.actor_type === 'admin') return '管理者';
  if (row.actor_type === 'artist') return 'アーティスト';
  return nonBlank(row.actor_type) || '不明';
};

const materialDownloadActorIdentifier = (row = {}) =>
  nonBlank(row.actor_identifier) || nonBlank(row.artist_user_id) || nonBlank(row.admin_user_id);

export const materialDownloadActorName = (row = {}) =>
  nonBlank(row.actor_display_name) ||
  nonBlank(row.admin_name) ||
  nonBlank(row.admin_nickname) ||
  nonBlank(row.admin_username) ||
  nonBlank(row.artist_name) ||
  nonBlank(row.artist_name_en) ||
  materialDownloadActorIdentifier(row) ||
  '不明';

export const materialDownloadActorIdentity = (row = {}) => {
  const email =
    nonBlank(row.actor_email) ||
    nonBlank(row.admin_email) ||
    nonBlank(row.artist_email) ||
    nonBlank(row.artist_provisional_email);
  const identifier = materialDownloadActorIdentifier(row);
  return [
    email ? `メール: ${email}` : '',
    identifier ? `ID: ${identifier}` : '',
  ].filter(Boolean).join(' / ');
};

export const toFolderId = (value) =>
  value === undefined || value === null || value === '' ? null : Number(value);

export const isAllowedFile = (file) => {
  if (!file) return false;
  if (file.size > MATERIAL_MAX_BYTES) return false;
  return ALLOWED_EXTENSIONS.has(getExt(file.name));
};

export const openOrSaveEventMaterial = async (material, { pdfPreview, onSuccess, onError }) => {
  try {
    if (!material?.file_key) {
      onError('資料ファイルの保存先を確認できませんでした');
      return;
    }
    const fileName = material.file_name || material.title || 'event-material';
    const { url } = await createStorageProxyUrl({ key: material.file_key, downloadName: fileName });
    if (isPdfPreviewable({ fileName, mimeType: material.mime_type || material.content_type, url }) && pdfPreview?.openPreview) {
      pdfPreview.openPreview({ url, fileName, mimeType: 'application/pdf' });
      return;
    }
    const saveHandle = await requestSaveFileHandle(fileName, { fallback: 'event-material' });
    if (saveHandle) {
      await writeBlobToFileHandle(saveHandle, await downloadBlobFromUrl(url, 'include'));
      onSuccess('資料を保存しました');
      return;
    }
    openExternalUrl(url);
    onSuccess('資料のダウンロードを開始しました');
  } catch (error) {
    if (!isSavePickerAbortError(error)) onError(error?.message || '資料のダウンロードに失敗しました');
  }
};
import { downloadBlobFromUrl } from '../../../api/storage';
import { createStorageProxyUrl } from '../../../api/venues';
import { openExternalUrl } from '../../../utils/externalLink';
import {
  isSavePickerAbortError,
  requestSaveFileHandle,
  writeBlobToFileHandle,
} from '../../../utils/fileSavePicker';
import { isPdfPreviewable } from '../pdf/PdfPreviewProvider';
